export const CustomStrategy = { info: { Name: 'Custom' } };
//# sourceMappingURL=CustomStrategy.js.map